import { TOUR_SHOWING_STATUS_FAILED } from 'common/tourConstants';
import { formatListingAddress } from 'common/formatters';
import typeCheck from 'common/util/typeCheck';
import getGoogleMapsDirectionUrl from 'common/util/getGoogleMapsDirectionsUrl';

export default function getTourListingsGoogleMapsDirectionsUrl(args) {
  typeCheck('args::NonEmptyObject', args);
  typeCheck('showings::Array', args.showings);
  typeCheck('listings::Array', args.listings);

  const tourShowingStatus = args.showings.reduce((memo, showing) => {
    return {
      ...memo,
      [showing.listingId]: showing.status,
    };
  }, {});
  const listings = args.listings.filter(
    (listing) => tourShowingStatus[listing.id] !== TOUR_SHOWING_STATUS_FAILED
  );

  if (!listings.length) {
    return null;
  }

  const directions = listings
    .map((listing) => formatListingAddress(listing, { hideApartmentNumber: true }));

  return getGoogleMapsDirectionUrl({
    directions,
    isIphoneApp: args.isIphoneApp,
  });
}
